import type { ReactNode } from "react";
import { motion } from "motion/react";

interface AnimatedContentProps {
  children: ReactNode;
  /** Travel distance in px for the entrance. */
  distance?: number;
  direction?: "vertical" | "horizontal";
  delay?: number;
  duration?: number;
  className?: string;
}

/**
 * ReactBits AnimatedContent — fades/slides its children in on mount.
 */
export default function AnimatedContent({
  children,
  distance = 30,
  direction = "vertical",
  delay = 0,
  duration = 0.6,
  className,
}: AnimatedContentProps) {
  const axis = direction === "vertical" ? "y" : "x";
  return (
    <motion.div
      className={className}
      initial={{ [axis]: distance, opacity: 0 }}
      animate={{ [axis]: 0, opacity: 1 }}
      transition={{ duration, delay, ease: [0.25, 0.46, 0.45, 0.94] }}
    >
      {children}
    </motion.div>
  );
}
